import styled from 'styled-components';
import { body1, colors, heading4, link2, spacing } from 'ui/theme';
import { pxToRem } from 'utils/convert';
import { COMPONENT_TYPE } from './constants';

const customSpacing = {
  p40: pxToRem(40),
  p136: pxToRem(136),
  p180: pxToRem(180),
  p260: pxToRem(260),
  p280: pxToRem(280),
  p344: pxToRem(344),
  p480: pxToRem(480),
};

export const DisplayCenterWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
`;

export const NoDataContainer = styled(DisplayCenterWrapper)<{ componentType: COMPONENT_TYPE }>`
  margin: ${({ componentType }) => {
    switch (componentType) {
      case COMPONENT_TYPE.CARD:
        return `${spacing.half} 0 ${spacing.double}`;

      case COMPONENT_TYPE.TABLE:
        return `${customSpacing.p136} 0 ${customSpacing.p344}`;

      case COMPONENT_TYPE.TAB:
        return `${customSpacing.p180} 0 ${customSpacing.p344}`;

      case COMPONENT_TYPE.TAKEOVER:
        return `${customSpacing.p280} auto 0`;
      case COMPONENT_TYPE.TAKEOVER_TABLE:
        return 0;
      default:
        return 0;
    }
  }};
  padding-top: ${({ componentType }) =>
    componentType === COMPONENT_TYPE.TAKEOVER_TABLE ? `${customSpacing.p180}` : 0};
  padding-bottom: ${({ componentType }) =>
    componentType === COMPONENT_TYPE.TAKEOVER_TABLE ? `${customSpacing.p260}` : 0};
`;

export const NoDataTitle = styled.span<{ componentType: COMPONENT_TYPE }>`
  ${heading4}
  margin-top: ${({ componentType }) => {
    switch (componentType) {
      case COMPONENT_TYPE.CARD:
      case COMPONENT_TYPE.TABLE:
      case COMPONENT_TYPE.TAKEOVER:
      case COMPONENT_TYPE.TAKEOVER_TABLE:
        return spacing.half;

      case COMPONENT_TYPE.TAB:
        return spacing.double;

      default:
        return 0;
    }
  }};
`;

export const NoDataSubTitle = styled.span<{ componentType: COMPONENT_TYPE }>`
  ${body1}
  color: ${colors.textSecondary};
  margin-top: ${spacing.half};
  text-align: center;
  max-width: ${({ componentType }) => {
    switch (componentType) {
      case COMPONENT_TYPE.CARD:
      case COMPONENT_TYPE.TABLE:
      case COMPONENT_TYPE.TAKEOVER_TABLE:
        return spacing.x40;

      case COMPONENT_TYPE.TAB:
        return spacing.x32;

      case COMPONENT_TYPE.TAKEOVER:
        return customSpacing.p480;

      default:
        return 0;
    }
  }};
`;

export const NoDataLink = styled.a`
  ${link2};
`;
